<template>
  <div class="templateData" v-if="templateData.length">
    <vxe-table border show-overflow highlight-hover-row ref="xTable1" max-height="600" :data="templateData" :sort-config="{ trigger: 'cell' }">
      <vxe-table-column field="name" title="合同模板名称">
        <template #default="{ row }">
          <el-tooltip class="item" effect="dark" :content="row.name" placement="top">
            <span>{{ row.name }}</span>
          </el-tooltip>
        </template>
      </vxe-table-column>
      <vxe-table-column field="type" title="字段类型">
        <template #default="{ row }">
          <el-select v-model="row.type" @change="typeChange(row)">
            <el-option v-for="item in typeList" :key="item.code" :value="item.code" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column field="dataSource" title="数据来源">
        <template #default="{ row }">
          <el-select v-model="row.dataSource" @change="dataSourceChange(row)">
            <el-option
              v-for="item in dataSourceList"
              :key="item.code"
              :value="item.code"
              :label="item.name"
              :disabled="(row.type === '3' || row.type === '1' || row.type === '4') && item.code !== '1'"
            ></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <!--子表模型实体-->
      <vxe-table-column field="boSubEntId" title="子表模型实体" show-overflow :key="Math.random()">
        <template #default="{ row }">
          <el-select
            filterable
            v-model="row.boSubEntId"
            v-if="(row.type === '3' || row.type === '4') && row.dataSource === '1'"
            @change="(params) => getboSubEntId(params, boSubEntIdList, childDefIdList, 'id', row)"
          >
            <el-option v-for="item in childDefIdList" :key="item.id" :value="item.id" :label="item.desc"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column field="boEntId" title="模型字段名" show-overflow>
        <template #default="{ row }">
          <!--文本 常量-->
          <el-select
            v-model="row.boEntId"
            v-if="row.type === '0' && row.dataSource === '0'"
            filterable
            @change="(params) => selName(params, propList, enumMapList, 'id', row)"
          >
            <el-option v-for="item in enumMapList" :key="item.id" :value="item.id" :label="item.desc"></el-option>
          </el-select>
          <!--文本 模型-->
          <el-select
            v-model="row.boEntId"
            v-if="row.type === '0' && row.dataSource === '1'"
            filterable
            @change="(params) => selName(params, propList, attrDefIdList, 'id', row)"
          >
            <el-option v-for="item in attrDefIdList" :key="item.id" :value="item.id" :label="item.desc"></el-option>
          </el-select>
          <!--数组 模型-->
          <el-select
            v-model="row.boEntId"
            v-if="row.type === '1' && row.dataSource === '1'"
            filterable
            @change="(params) => selName(params, propList, childDefIdList, 'id', row)"
          >
            <el-option v-for="item in childDefIdList" :key="item.id" :value="item.id" :label="item.desc"></el-option>
          </el-select>
          <!--数组字段 模型-->
          <el-select
            v-model="row.boEntId"
            filterable
            v-if="(row.type === '3' || row.type === '4') && row.dataSource === '1'"
            @change="(params) => selName(params, propList, dataBoSubEntIdChange(row), 'id', row)"
          >
            <el-option v-for="item in dataBoSubEntIdChange(row)" :key="item.id" :value="item.id" :label="item.desc"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <!--数据转换规则别名-->
      <vxe-table-column field="dataConvert" title="转换类型" show-overflow>
        <template #default="{ row }">
          <el-select filterable v-model="row.dataConvert" @change="changeConvert(row)" v-if="row.type !== '2' && row.type !== '1' && row.dataSource !== '0'">
            <el-option v-for="item in dataConvertList" :key="item.id" :value="item.id" :label="item.desc"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <!--表单别名转换-->
      <vxe-table-column field="dataConvertValue" title="类型转换" show-overflow>
        <template #default="{ row }">
          <el-select
            filterable
            v-model="row.dataConvertValue"
            v-if="dataConvertChange(row) && dataConvertChange(row).length && row.type !== '2' && row.type !== '1' && row.dataSource !== '0' && row.dataConvert"
          >
            <el-option v-for="item in dataConvertChange(row)" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 是否必填 -->
      <vxe-table-column field="isRequired" title="必填" show-overflow>
        <template #default="{ row }">
          <el-select v-model="row.isRequired" v-if="row.dataSource == 2">
            <el-option v-for="item in requiredList" :key="item.code" :value="item.code" :label="item.name"></el-option>
          </el-select>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import * as constants from './constants.js'
import form from '@/api/form'
export default {
  name: 'tempObjectTable',
  data() {
    return {
      ...constants,
      enumMapList: [],
      attrDefIdList: [],
      childDefIdList: [],
      dataConvertList: [],
      propList: [
        {
          name: 'boEntName',
          key: 'desc'
        },
        {
          name: 'boEntAlias',
          key: 'name'
        }
      ],
      boSubEntIdList: [
        {
          name: 'boSubEntName',
          key: 'desc'
        },
        {
          name: 'boSubEntAlias',
          key: 'name'
        }
      ]
    }
  },
  props: {
    templateData: {
      type: Array,
      default: () => []
    },
    defId: {
      type: String,
      default: () => ''
    }
  },
  mounted() {
    this.getBoDefIdList()
    this.getBoDefIdListMap()
  },
  watch: {
    defId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getChildListByDefId(newVal)
        this.getAttrListByDefId(newVal)
      }
    }
  },
  methods: {
    transDict(value, list) {
      let a = list.find((item, index) => index === value)
      return a ? a : ''
    },
    // 获取模板字段名
    getBoDefIdList() {
      form.getDetailListByEnumMap().then((resp) => {
        this.enumMapList = resp
      })
    },
    // 数据转换规则别名
    getBoDefIdListMap() {
      form.getDetailListByEnumConvertMap().then((resp) => {
        this.dataConvertList = resp
      })
    },
    // 获取模板字段名
    getChildListByDefId(newVal) {
      let params = {
        defId: newVal
      }
      form.getChildListByDefId(params).then((resp) => {
        this.childDefIdList = resp
      })
    },
    // 获取模板字段名
    getAttrListByDefId(newVal) {
      let params = {
        defId: newVal
      }
      form.getAttrListByDefId(params).then((resp) => {
        this.attrDefIdList = resp
      })
    },
    typeChange(row) {
      row.dataSource = ''
    },
    dataSourceChange(row) {
      row.boEntName = ''
      row.boEntId = ''
      row.boEntAlias = ''
      row.boSubEntName = ''
      row.boSubEntId = ''
      row.boSubEntAlias = ''
    },
    changeConvert(row) {
      row.dataConvertValue = ''
    },
    // 选择类型，赋值类型转换
    dataConvertChange(row) {
      if (row.dataConvert) {
        let bb = this.dataConvertList.find((item) => item.id === row.dataConvert)
        if (bb) return bb.child
      }
      return []
    },
    // 子表模型
    getboSubEntId(value, nameList, list, listKey = 'code', row) {
      this.dataBoSubEntIdChange(row)
      this.selName(value, nameList, list, listKey, row)
    },
    dataBoSubEntIdChange(row) {
      if (row.boSubEntId) {
        let bb = this.childDefIdList.find((item) => item.id === row.boSubEntId)
        if (bb) return bb.attributeList
      }
      return []
    },
    /**
     *
     * @param value value
     * @param nameList 赋值nameList
     * @param list 查找的list
     * @param listKey code转换
     * @param row
     */
    selName(value, nameList, list, listKey = 'code', row) {
      let temp = list.find((item) => item[listKey] === value)
      if (temp) {
        nameList.forEach((item) => {
          row[item.name] = temp[item.key]
        })
      }
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.templateData {
  margin-top: 10px;
}
</style>
